import React, { useEffect, useRef, useState } from "react";
import { Modal, Input } from "antd";
import { TextAreaRef } from "antd/lib/input/TextArea";

interface Props {
  open: boolean;
  title: string;
  description?: string;
  placeholder?: string;
  okText?: string;
  okDanger?: boolean;
  onConfirm: (reason: string) => void;
  onCancel: () => void;
}

const ReasonModal: React.FC<Props> = ({
  open,
  title,
  description,
  placeholder,
  okText = "Confirm",
  okDanger = false,
  onConfirm,
  onCancel,
}) => {
  const [reason, setReason] = useState("");
  const inputRef = useRef<TextAreaRef>(null);

  useEffect(() => {
    if (open) {
      setReason("");
      const focusTimer = setTimeout(() => inputRef.current?.focus(), 50);
      return () => clearTimeout(focusTimer);
    }
    return undefined;
  }, [open]);

  const trimmed = reason.trim();
  const handleOk = (): void => {
    if (!trimmed) return;
    onConfirm(trimmed);
  };

  return (
    <Modal
      visible={open}
      title={title}
      onCancel={onCancel}
      onOk={handleOk}
      okText={okText}
      okButtonProps={{ disabled: !trimmed, danger: okDanger }}
      cancelText="Cancel"
      destroyOnClose
    >
      {description && (
        <p style={{ color: "rgba(0,0,0,0.65)", marginBottom: 12 }}>
          {description}
        </p>
      )}
      <Input.TextArea
        ref={inputRef}
        rows={3}
        value={reason}
        placeholder={placeholder || "Write a short reason…"}
        onChange={(event) => setReason(event.target.value)}
        onPressEnter={(event) => {
          if (!event.shiftKey) {
            event.preventDefault();
            handleOk();
          }
        }}
      />
    </Modal>
  );
};

export default ReasonModal;
